import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { GetPopularCollectionUsecase } from '@modules/collections/application/usecases/getPopularCollection.usecase';
import { IPopularCollection } from '@modules/collections/domain/models/popularCollection.model';
import { loadingStore } from '@modules/core/adapter/outbound/stores/ui.store';
import { PopularCollectionRepositoryImpl } from '../../inbound/repositories/popularCollection.repository';
interface PopularCollectionState {
  popularCollectionList: IPopularCollection[];
  setPopularCollectionList: () => void;
}
const initialState: IPopularCollection[] = [];
export const popularCollectionStore = create<PopularCollectionState>()(devtools(set => ({
  popularCollectionList: initialState,
  setPopularCollectionList: async (): Promise<void> => {
    try {
      loadingStore.setState({
        isLoading: true
      });
      const popularCollectionRepositoryImpl = new PopularCollectionRepositoryImpl();
      const getPopularCollectionUsecase = new GetPopularCollectionUsecase(popularCollectionRepositoryImpl);
      const result = await getPopularCollectionUsecase.handle();
      if (result.isRight()) {
        set(() => ({
          popularCollectionList: result.value
        }));
      }
    } catch (err) {
      console.error('error setPopularCollectionList', err);
    } finally {
      loadingStore.setState({
        isLoading: false
      });
    }
  }
})));